//Complimetary all
import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Input,
  Row,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { Triangle } from "react-loader-spinner";
import Flatpickr from "react-flatpickr";
import { Link } from "react-router-dom";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import ComplimentryService from "../../../services/OrderingServices/ComplimentryService";
import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";

import useTableSearch from "../../../hooks/useTableSearch";
import TableSearch from "../../../Components/Common/TableSearch";
const SummaryCard = ({ title, value, color, icon }) => (
  <Card className="shadow-sm card-animate border-0">
    <CardBody className="d-flex align-items-center justify-content-between">
      <div className="w-100">
        <h6 className="fw-semibold text-uppercase" style={{ color }}>
          {title}
        </h6>
        <div className="d-flex justify-content-between w-100">
          <h4 className="fs-2 fw-bold" style={{ color }}>
            {value}
          </h4>
          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              backgroundColor: color + "20",
              color: color,
              width: "36px",
              height: "36px",
            }}
          >
            <i className={`${icon} fs-5`} />
          </div>
        </div>
      </div>
    </CardBody>
  </Card>
);

const ComplimentryAll = () => {
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
    totalData: 0,
  });
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);

  // Summary stats
  const [totalLogs, setTotalLogs] = useState(0);
  const [totalQuantityGiven, setTotalQuantityGiven] = useState(0);
  const [uniqueItemsCount, setUniqueItemsCount] = useState(0);
  const [totalOrdersAffected, setTotalOrderAffected] = useState(0);

  // filters
  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);

  const [dateRange, setDateRange] = useState([oneMonthAgo, today]);
  const [filterName, setFilterName] = useState("");
  const [filterOrderId, setFilterOrderId] = useState("");

  const formatDate = (date) => {
    if (!date) return null;
    return date.toLocaleDateString("en-CA");
  };

  // Calculate summary stats
  // const calculateStats = (data) => {
  //   if (!data || data.length === 0) {
  //     setTotalItems(0);
  //     setTotalQuantity(0);
  //     setUniqueOrders(0);
  //     return;
  //   }

  //   const total = data.length;
  //   const qty = data.reduce((sum, item) => sum + (item.quantity || 0), 0);
  //   const orders = new Set(data.map((item) => item.orderId)).size;

  //   setTotalItems(total);
  //   setTotalQuantity(qty);
  //   setUniqueOrders(orders);
  // };

  const fetchData = async (
    page = 1,
    pageSize = pagination.pageSize,
    name = filterName,
    orderId = filterOrderId
  ) => {
    setLoading(true);
    try {
      let apiData;

      // If filtering by order ID
      if (orderId) {
        apiData = await ComplimentryService.getByOrder(orderId);

        setTotalLogs(apiData?.summary?.totalLogs || 0);
        setTotalQuantityGiven(apiData?.summary?.totalQuantityGiven || 0);
        setUniqueItemsCount(apiData?.summary?.uniqueItemsCount || 0);
        setTotalOrderAffected(apiData?.summary?.totalOrdersAffected || 0);

        setAllData(apiData?.items || []);

        setPagination({
          currentPage: page,
          pageSize,
          totalPages: 1,
          totalData: apiData?.items?.length || 0,
        });

        return;
      }

      // Normal listing
      apiData = await ComplimentryService.getAll({
        page,
        pageSize,
        itemName: name || "",
        startDate: formatDate(dateRange[0]),
        endDate: formatDate(dateRange[1]),
      });

      // Summary
      setTotalLogs(apiData?.summary?.totalLogs || 0);
      setTotalQuantityGiven(apiData?.summary?.totalQuantityGiven || 0);
      setUniqueItemsCount(apiData?.summary?.uniqueItemsCount || 0);
      setTotalOrderAffected(apiData?.summary?.totalOrdersAffected || 0);

      // Table data
      setAllData(apiData?.items || []);

      // Pagination – now CORRECT
      setPagination({
        currentPage: page,
        pageSize,
        totalPages: apiData?.totalPages || 0,
        totalData: apiData?.totalCount || 0,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllData([]);
      setPagination((prev) => ({ ...prev, totalData: 0 }));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(1, pagination.pageSize, filterName, filterOrderId);
  }, [dateRange, filterName, filterOrderId]);

  const columns = [
    {
      name: "S.N",
      selector: (row, index) =>
        (pagination.currentPage - 1) * pagination.pageSize + index + 1,
      sortable: false,
      width: "75px",
    },
    {
      name: "Order Ref Number",
      selector: (row) => row.orderRefNumber,
      sortable: true,
      cell: (row) => (
        <Link
          to={`/complimentry-logs/detail/${row?.orderRefNumber}`}
          title={row?.orderRefNumber}
        >
          {row?.orderRefNumber}
        </Link>
      ),
    },
    {
      name: "Name",
      selector: (row) => row.itemName,
      cell: (row) => (
        <Link to={`/item/detail/${row?.itemId}`}>{row.itemName}</Link>
      ),
      sortable: true,
    },
    {
      name: "Qty",
      selector: (row) => row.quantity,
      sortable: true,
      width: "6rem",
      center: true,
    },
    {
      name: "Given By",
      selector: (row) => row.givenBy,
      sortable: true,
      center: true,
    },
  ];

  const { searchTerm, setSearchTerm, filteredData } = useTableSearch(allData, [
    "orderRefNumber",
    "itemName",
    "quantity",
    "givenBy",
  ]);

  const getDateRangeDisplay = () => {
    if (!dateRange[0] || !dateRange[1]) return "All Time";
    const start = new Date(dateRange[0]).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
    const end = new Date(dateRange[1]).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
    return `${start} - ${end}`;
  };

  return (
    <>
      {/* Summary Cards */}
      <div className="p-3 p-lg-4" style={{ background: "#f8f9fa" }}>
        <Row className="mt-2">
          <Col lg={3} md={6} sm={12}>
            <SummaryCard
              title="Total Logs"
              value={totalLogs}
              color="#0d6efd"
              icon="bx bx-package"
            />
          </Col>
          <Col lg={3} md={6} sm={12}>
            <SummaryCard
              title="Total Comp Qty"
              value={totalQuantityGiven}
              color="#28a745"
              icon="bx bx-bar-chart-alt-2"
            />
          </Col>
          <Col lg={3} md={6} sm={12}>
            <SummaryCard
              title="Unique Orders"
              value={uniqueItemsCount}
              color="#17a2b8"
              icon="bx bx-receipt"
            />
          </Col>{" "}
          <Col lg={3} md={6} sm={12}>
            <SummaryCard
              title="Total Orders Affected"
              value={totalOrdersAffected}
              color="#17a2b8"
              icon="bx bx-receipt"
            />
          </Col>
        </Row>
      </div>

      {/* Main Content */}
      <div className="p-3 p-lg-4 mt-1">
        <Row className="mb-3 g-2">
          <Col md={4}>
            <div>
              <h5 className="mb-1 fw-bold text-dark">Complimentary Logs</h5>
              <p className="text-muted small mb-0">{getDateRangeDisplay()}</p>
            </div>
          </Col>
          <Col md={4}>
            <TableSearch
              value={searchTerm}
              onChange={setSearchTerm}
              placeholder="Search by all.."
            />
          </Col>
          <Col md={4}>
            <InputGroup>
              <Flatpickr
                options={{ mode: "range", dateFormat: "Y-m-d" }}
                value={dateRange}
                onChange={(dates) => setDateRange(dates)}
                className="form-control"
                placeholder="Select date range"
              />
              <InputGroupText style={{ cursor: "pointer" }}>
                <i className="bx bx-calendar"></i>
              </InputGroupText>
            </InputGroup>
          </Col>
        </Row>

        <hr style={{ borderColor: "#dee2e6", marginTop: "0rem" }} />

        {/* Filters
        <Row className="mb-3 g-2">
          <Col md={4}>
            <InputGroup>
              <TableSearch
                value={searchTerm}
                onChange={setSearchTerm}
                placeholder="Search by all.."
              />
              <InputGroupText>
                <i className="bx bx-search"></i>
              </InputGroupText>
            </InputGroup>
          </Col>
          <Col md={4}>
            <InputGroup>
              <Input
                type="text"
                placeholder="Search by Order Id"
                value={filterOrderId}
                onChange={(e) => setFilterOrderId(e.target.value)}
              />
              <InputGroupText>
                <i className="bx bx-hash"></i>
              </InputGroupText>
            </InputGroup>
          </Col>
          <Col md={4}>
            <InputGroup>
              <Flatpickr
                options={{ mode: "range", dateFormat: "Y-m-d" }}
                value={dateRange}
                onChange={(dates) => setDateRange(dates)}
                className="form-control"
                placeholder="Select date range"
              />
              <InputGroupText style={{ cursor: "pointer" }}>
                <i className="bx bx-calendar"></i>
              </InputGroupText>
            </InputGroup>
          </Col>
        </Row> */}

        {/* Table */}
        <CustomDataTable
          responsive
          striped
          pagination
          paginationServer
          paginationTotalRows={pagination.totalData}
          paginationDefaultPage={pagination.currentPage}
          onChangePage={(page) =>
            fetchData(page, pagination.pageSize, filterName, filterOrderId)
          }
          onChangeRowsPerPage={(newPageSize) =>
            fetchData(1, newPageSize, filterName, filterOrderId)
          }
          fixedHeader
          highlightOnHover
          pointerOnHover
          persistTableHead
          progressPending={loading}
          customStyles={{
            headCells: {
              style: {
                fontSize: "0.92rem",
                fontWeight: 610,
              },
            },
            rows: {
              style: {
                fontSize: "0.9rem",
              },
            },
          }}
          progressComponent={
            <div className="my-3 text-center">
              <Triangle visible height="80" width="80" color="#5B71B9" />
              <h5 className="mt-1">Loading...</h5>
            </div>
          }
          columns={columns}
          data={filteredData}
          noDataComponent={
            <div className="text-center my-5 w-100">
              <i className="ri-emotion-unhappy-line display-4 text-secondary" />
              <h5 className="fw-semibold text-secondary">No Data Found</h5>
              <p className="text-muted mb-0">
                No complimentary logs found for the selected filters.
              </p>
            </div>
          }
        />
      </div>
    </>
  );
};

export default ComplimentryAll;
